<div
  class="image-container container"
  style="background-image: url('/assets/images/about-us/project.webp')"
>
</div>

<h1
  class="page-title"
>
  Proiect
</h1>

<div class="container">
  <p>
    Proiectul Dream Residence a luat naștere în urma dorinței de a transforma locuință ideală mult visată în realitate. De aceea, pentru noi a fost foarte important să alegem o locație potrivită în care să le oferim să punem bazele nu numai unui nou cartier, ci a unei noi comunități care îndeplinește aceleași principii și valori. Nimic nu e mai important decât siguranța ta. Astfel, comunitatea Dream Residence este o comunitate sigură, caldă, fericită, un loc perfect pentru familia ta în noul cartier Rahova.
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/about-us/project.component.html